/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Schema keys for claim response
 */
const schemaKeys = {
	eftChequeNo: 'eftChequeNo',
	eraNumber: 'eraNumber',
	clearingHouse: 'clearingHouse',
	id: 'id',
	serviceLines: 'serviceLines',
	paymentDetails: 'paymentDetails',
	reviewOutcome: 'reviewOutcome',
	allowedAmount: 'allowedAmount',
	paidAmount: 'paidAmount',
	patientResponsibility: 'patientResponsibilityAmount',
	adjustedAmount: 'adjustedAmount',
	revenueCode: 'revenueCode',
	HCPCSCode: 'HCPCSCode',
	modifier: 'modifier',
	quantity: 'quantity',
	billedAmount: 'billedAmount',
	lineAdjudication: {
		key: 'lineAdjudication',
		group: 'group',
		reasonCode: 'reasonCode',
		amount: 'amount',
	},
	paymentDate: 'paymentDate',
	paymentCheckNumber: 'paymentCheckNumber',
	paymentCheckDate: 'paymentCheckDate',
	paymentSummary: 'paymentSummary',
	claimStatus: 'statusDetails',
} as const;

type SchemaKeys = typeof schemaKeys;

export { schemaKeys };
export type { SchemaKeys };
